<div [class.admin-sender]="message.sender.account_id === (senderService.account$ | async)?.id"
     class="message-body message-out message-text-long">

  <!--<nz-spin *ngIf="message.sender.current_count == 0; else showMessage" nzTip="Ожидание, запуск в течение 5 минут">
    <ng-template [ngTemplateOutlet]="messageTmpl"></ng-template>
  </nz-spin>

  <ng-template #showMessage>
    <ng-template [ngTemplateOutlet]="messageTmpl"></ng-template>
  </ng-template>-->
  <ng-template [ngTemplateOutlet]="messageTmpl"></ng-template>
</div>


<ng-template #date>
  <small class="message-date opacity-65 mr-2">{{ message.date * 1000 | date: 'dd.M.y' }}</small>
  <small class="message-time opacity-65 mr-2">{{ message.date * 1000 | date: 'H:mm' }}</small>
</ng-template>
<ng-template #messageTmpl>

  <div [attr.data-percent]="percent" [attr.data-success-percent]="successPercent" class="message-content">
    <div class="d-flex">
      <nz-progress class="mr-5" [nzStrokeWidth]="8" [nzPercent]="percent"
                   [nzSuccessPercent]="successPercent" nzType="circle"
                   [nzWidth]="80" [nzStrokeColor]="color"></nz-progress>
      <div>
        <!--<h6 class="mb-2 font-weight-bold">{{message.sender.name || 'Рассылка'}}</h6>-->
        <div class="text-break text-white d-inline-block">
          <div>
            Начало: <b>{{message.sender.start_date | date: 'MMM d, y, HH:mm'}}</b>
          </div>
          <div *ngIf="isCompletedDate">
            Завершение<span *ngIf="isLoop"> цикла</span>:
            <b>{{message.sender.end_date | date: 'MMM d, y, HH:mm'}}</b><br>
          </div>
          <div *ngIf="isPost">
            <div>
              Сообщение: <a class="pointer" [href]="message.sender.post_link" target="_blank">
              {{message.sender.post_link}}</a>
            </div>
          </div>
          <div *ngIf="isParse">
            <div>
              Чат/канал: <a class="pointer" (click)="openDetailInfo()">{{message.sender.parsed_chat}}</a>
            </div>
            <div *ngIf="!lastParseError">
              <span class="parsing-status">
                <i-feather *ngIf="isParsingCompleted" name="check" class="text-success"></i-feather>
                <nz-spin *ngIf="!isParsingCompleted && !isPause" [style.height.px]="10" class="d-inline-block" nzSimple
                         [nzSize]="'small'"></nz-spin>
              </span>
              {{isParsingCompleted ? 'Парсинг завершен' : 'Прогресс парсинга'}}:
              <span> <b>{{message.sender.parsed_count}}</b></span>
              <span
                *ngIf="message.sender.parsed_members_count > 0"> из <b>{{message.sender.parsed_members_count}}</b></span>
              <ng-template [ngIf]="isParsingCompleted">
                &nbsp;|&nbsp;
                <a href="javascript:void(0)" class="font-normal mx-2 text-nowrap"
                   (click)="senderService.downloadParsed('xls', message.sender.id)">
                  <i-feather name="download-cloud" class="mr-2"></i-feather>&nbsp;скачать</a>
                &nbsp;|&nbsp;
                <a class="font-normal ml-2 text-nowrap" target="_blank"
                   [href]="senderService.getViewUrlXml(message.sender.id)">
                  <i-feather name="eye" class="mr-2"></i-feather>&nbsp;смотреть
                </a>
              </ng-template>

            </div>
          </div>
          <div *ngIf="message.sender.current_count; else fatalRef">
            <nz-spin
              *ngIf="!lastError && !isPause && !isBanned && ((isParse && isParsingCompleted && !isCompleted) || !isCompleted)"
              [style.height.px]="10" class="d-inline-block" nzSimple [nzSize]="'small'"></nz-spin>
            <i-feather *ngIf="isBanned"
                       tooltip="Остановлено для прекращения блокировок остальных аккаунтов, измените текст и ссылки."
                       placement="top" name="alert-triangle" class="text-warning"></i-feather>

            Отправлено:
            <span (click)="senderService.showResultsModal(message)"
                  class="badge badge-light py-2 text-success pointer">{{currentSendCount}}</span>
            из
            <b>{{totalSend - fatalCount}}</b>
            <span *ngIf="errorCount > 0">, c ошибкой: <span>{{errorCount}}</span></span>
            <span *ngIf="fatalCount > 0">, пропущено нерабочих контактов:
              <span (click)="senderService.showErrorsModal(message)"
                    class="badge badge-light py-2 text-danger pointer">{{fatalCount}}</span></span>
          </div>
          <ng-template #fatalRef>
            <span *ngIf="fatalCount > 0">Пропущено нерабочих контактов:
              <span (click)="senderService.showErrorsModal(message)"
                    class="badge badge-light py-2 text-danger pointer">{{fatalCount}}</span></span>
          </ng-template>
          <div *ngIf="!message.sender.current_count && !isParse">
            Получателей: <b>{{message.sender.total_send}}</b>
          </div>
          <div *ngIf="isLoop">
            Повторов: <b>{{message.sender.loop_count}}</b>
            <span> из <b>{{message.sender.loop_need_count}}</b></span>
          </div>
        </div>
      </div>
    </div>
    <div (click)="contextMenuOpen.next({ event: $event, message: message })" class="btn-more pointer">
      <i-feather name="chevron-down" class="icon-lg"></i-feather>
    </div>

    <div
      *ngIf="message.sender.text"
      [innerHTML]="message.sender.text | replaceEmojis: 'facebook':24:64"
      class="sender--text small mt-2 text-truncate"
    ></div>
    <div class="message-bottom mt-2 d-flex justify-content-between align-items-center">

      <div *ngIf="senderService.isAdmin" class="text-muted small">

        <a target="_blank"
           href="https://messenger.soft-angel.ru:8003/admin/sender/senderslist/{{message.sender.id}}/change/">#{{message.sender.id}}</a>
        &nbsp;<a target="_blank"
                 href="https://messenger.soft-angel.ru:8003/admin/sender/accounts/{{message.sender.account_id}}/change/">{{message.sender.account_id}}</a>
      </div>
      <div *ngIf="!senderService.isAdmin" class="text-muted small">
        #{{message.sender.id}}
      </div>
      <div [ngSwitch]="message.sender?.type || 0">
        <ng-template [ngSwitchCase]="0">
          <i-feather tooltip="Стандарт" placement="top" name="message-square" class="text-white"></i-feather>
        </ng-template>
        <ng-template [ngSwitchCase]="1">
          <i-feather tooltip="Накрутка" placement="top" name="trending-up" class="text-white"></i-feather>
        </ng-template>
        <ng-template [ngSwitchCase]="2">
          <i-feather tooltip="Пост/сообщение" placement="top" name="media" class="text-white"></i-feather>
        </ng-template>
        <ng-template [ngSwitchCase]="3">
          <i-feather tooltip="Парсинг" placement="top" name="cpu" class="text-white"></i-feather>
        </ng-template>
      </div>
      <div tooltip="Прикрепленно файлов" placement="top" *ngIf="message.sender?.attachments">
        <i-feather name="file-plus"></i-feather>&nbsp;<small>{{attachmentsCount}}</small>
      </div>
      <div tooltip="Добавлено вариантов текста" placement="top" *ngIf="message.sender?.text_variations">
        <i-feather name="file-text"></i-feather>&nbsp;<small>{{textsCount}}</small>
      </div>


      <!-- Status -->
      <div *ngIf="status as item; else satatusText;">
        <div [tooltip]="item?.tooltip" placement="top" class="text-white small">
          <nz-spin *ngIf="item.load" [style.height.px]="12" class="d-inline-block" nzSimple
                   [nzSize]="'small'"></nz-spin>
          <i-feather *ngIf="!item.load" [name]="item.icon" [class]="item.icon_class"></i-feather>&nbsp;
          {{item.text}}
          <span *ngIf="item?.time">{{item.time | timeago}}</span>
        </div>
      </div>

      <ng-template #satatusText>
        <div *ngIf="lastError" placement="top" class="text-white small">
          <div [ngSwitch]="lastError">
            <ng-template ngSwitchCase="CHAT_ADMIN_REQUIRED">
              <i-feather name="alert-triangle" class="text-danger"></i-feather>&nbsp;
              Список подписчиков доступен только админам.
            </ng-template>
            <ng-template ngSwitchCase="PEER_FLOOD_ACCOUNTS">
              <i-feather tooltip="Рассылка автоматически приостановлена для защиты от бана аккаунтов на сутки." placement="top" name="info" class="text-warning pointer"></i-feather>
              Приостановлена, можете продолжить, если не вылетело часть аккаунтов, лучше заменить канал и ссылку на сообщение
            </ng-template>
            <ng-template ngSwitchCase="PEER_FLOOD_LIMIT">
              <i-feather (click)="modalService.openModal('SendLimitComponent', {});" tooltip="Подробнее о лимитах" placement="top" name="info" class="text-warning pointer"></i-feather>
              Лимит на аккаунтах исчерпан. Ожидайте или <a href="javascript:void(0)" (click)="addAccount()">добавьте больше</a>.
            </ng-template>
            <ng-template ngSwitchCase="ACCOUNTS_NONE">
              <i-feather name="alert-triangle" class="text-danger"></i-feather>&nbsp;
              У вас нет телеграмм аккаунтов,
              <a href="javascript:void(0)" (click)="addAccount()">
                добавьте, для начала рассылки
              </a>
            </ng-template>
            <ng-template ngSwitchCase="NO_BALANCE">
              <ng-template [ngIf]="(senderService.account$ | async)?.balance < 26 || senderService.isAdmin()">
                <i-feather name="alert-triangle" class="text-danger"></i-feather>
                &nbsp;<a class="pointer text-underline"
                         (click)="modalService.openModal('ModalAddBalanceComponent')">Пополните
                баланс</a>
              </ng-template>
            </ng-template>
            <ng-template ngSwitchCase="NO_TOKENS">
              <i-feather name="alert-triangle" class="text-warning"></i-feather>&nbsp;
              <a href="javascript:void(0)" (click)="addAccount()">
                Ожидайте или добавьте больше
              </a> аккаунтов
            </ng-template>
            <ng-template ngSwitchCase="USERNAME_NOT_OCCUPIED">
              <i-feather name="alert-triangle" class="text-warning"></i-feather>&nbsp;
              Ссылка на группу или чат невалидна.
            </ng-template>
            <ng-template [ngIf]="isFoodWait">
              <i-feather name="alert-triangle" class="text-warning"></i-feather>&nbsp;Ожидайте окончания
              лимита {{floodWaitTime}} мин.<a
              href="javascript:void(0)" (click)="addAccount()"> или добавьте больше</a>
              аккаунтов
            </ng-template>
            <ng-template [ngIf]="isPercentFoodWait">
              <i-feather name="alert-triangle" class="text-warning"></i-feather>&nbsp;Ожидайте выхода из флуда 50%
              аккаунтов.<a href="javascript:void(0)" (click)="addAccount()"> или добавьте
              больше</a> аккаунтов
            </ng-template>
            <ng-template ngSwitchDefault>
              <ng-template [ngIf]="!isFoodWait && !isPercentFoodWait">
                {{message.sender.parsed_status || message.sender.last_error || 'Неопознааня ошибка, напишите нам'}}
              </ng-template>
            </ng-template>
          </div>
        </div>
      </ng-template>
      <!-- Status end -->
    </div>
    <div *ngIf="isBanned" class="alert alert-danger">
      <i-feather name="alert-triangle" class="text-white"></i-feather>
      При попытке отправить  {{
      appService.declOfNum(message.sender.banned_count, [
        'был забанен # аккаунт',
        'было забанено # аккаунта',
        'было забанено # аккаунтов'
      ])
      }}, рекомендуем <a class="text-underline text-white font-bold pointer" (click)="onEditMessage.emit(message)">заменить</a>
      текст, создать несколько вариантов текста и обновить ссылку, если она есть, после изменения рассылка продолжится.
      Так же используйте только Российские аккаунты.
    </div>
  </div>


</ng-template>

